import { LimitingWrapper } from '@gc-bridge/components/Container/LimitingWrapper';
import { Category as CategoryComponent } from '@gc-bridge/components/Section/Category';
import { SectionProps } from '@gc-bridge/models';
import { AdditionalColors } from '@gc-bridge/theme/colors';
import { Box, BoxProps, Typography, styled } from '@mui/material';

const Container = styled(Box)<BoxProps & { backgroundColor?: string }>(
  ({ backgroundColor, theme: { palette } }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    paddingTop: '64px',
    backgroundColor: backgroundColor ?? palette.background.paper,
  })
);

const Title = styled(Typography)({
  fontWeight: 700,
  fontSize: '90px',
  lineHeight: '95px',
  letterSpacing: '1.06px',
  color: AdditionalColors.InterstellarBlue,
});

const CardsContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(400px, 1fr)',
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(2, minmax(400px, 1fr))',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(3, minmax(400px, 1fr))',
  },
  width: '100%',
  gap: '16px',
}));

const Triangle = styled(Box)<BoxProps & { color: string }>(({ color }) => ({
  clipPath: 'polygon(0 0, 0 100%, 100% 100%)',
  backgroundColor: color,
  height: '70px',
  width: '100%',
}));

interface Props {
  section: SectionProps;
}

export function Section({ section }: Props) {
  return (
    <Container backgroundColor={section.backgroundColor}>
      <LimitingWrapper>
        <Box display="flex" flexDirection="column" gap="6px">
          <Title>{section.title}</Title>
        </Box>
        <Typography variant="h5" fontSize="30px" letterSpacing="0.15px">
          {section.description}
        </Typography>
        <CardsContainer>
          {section.categories.map((category) => (
            <CategoryComponent key={category.id} category={category} />
          ))}
        </CardsContainer>
      </LimitingWrapper>
      <Triangle color={section.separatorColor} />
    </Container>
  );
}
